<template>
<div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" v-bind:data-backdrop="backdrop">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        backdrop: {
            default: 'true'
        }
    }
}
</script>